<template>
    <dialogWrap v-model="isShow" :title="isEdit ? '编辑账户' : '新增账户'" width="420px">
        <form-text-box
            ref="partnerAccountBox"
            :column="1"
            :dataList="accountList"
            :rules="accountRules"
            :formProps="formProps"
            :model="model"
        ></form-text-box>
        <template slot="footer">
            <div class="footer">
                <el-button size="small" @click="() => isShow = false">取消</el-button>
                <el-button :loading="loading" size="small" type="primary" @click="submit">{{ isEdit ? '保存' : '开户' }}</el-button>
            </div>
        </template>
    </dialogWrap>
</template>

<script>
import { getSubAccountDetail, getWithholdingBankType, saveSubAccount } from '@/api/domain/finance'
import { filter, merge, pick } from 'lodash'
import { mapGetters } from 'vuex'
import config from './config'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    accountId: {
      type: [Number, String],
    },
  },
  data() {
    const { accountList, accountRules } = config.call(this)
    return {
      isShow: false,
      loading: false,
      accountList,
      accountRules,
      formProps: {
        labelWidth: '180px',
      },
      model: {
        channelType: '',
        merchantName: '',
        licenceNo: '',
        legalContactName: '',
        legalContactMobile: '',
        legalIdType: '',
        legalIdNo: '',
      },
    }
  },
  methods: {
    submit() {
      this.$refs.partnerAccountBox.getRefs().validate(async (validate) => {
        if (validate) {
          const params = ['accountId', 'channelType', 'merchantName', 'licenceNo', 'legalContactName', 'legalContactMobile', 'legalIdType', 'legalIdNo']
          const req = this.isEdit ? pick(this.model, params) : pick(this.model, filter(params, (item) => item !== 'accountId'))

          const { code, data } = await saveSubAccount({
            ...req,
          })
          if (code === 1) {
            if (data.result) {
              this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`)
            } else {
              this.$message.error(data.info)
            }
            this.isShow = false
            this.$emit('submitSucc')
          }
        }
      })
    },
    async getChannelTabList() {
      const { code, data } = await getWithholdingBankType()
      if (code === 1) {
        this.$refs.partnerAccountBox.setItemData({ elConfigKey: 'list', key: 'channelType', data })
      }
    },
    async getSubAccountModel() {
      const { code, data, msg } = await getSubAccountDetail({
        accountId: this.accountId,
        type: 2,
      })
      if (code === 1) {
        this.model = merge(this.model, data)
      } else {
        this.$message.error(msg)
      }
    },
  },
  watch: {
    show(val) {
      this.isShow = val
    },
    isShow(val) {
      if (val) {
        this.getChannelTabList()

        if (this.isEdit) {
          this.getSubAccountModel()
          this.$nextTick(() => {
            this.$refs.partnerAccountBox.setItemData({ elConfigKey: 'disabled', key: 'merchantName', data: true })
            this.$refs.partnerAccountBox.setItemData({ elConfigKey: 'disabled', key: 'licenceNo', data: true })
          })
        } else {
          this.$nextTick(() => {
            this.$refs.partnerAccountBox.setItemData({ elConfigKey: 'disabled', key: 'merchantName', data: false })
            this.$refs.partnerAccountBox.setItemData({ elConfigKey: 'disabled', key: 'licenceNo', data: false })
          })
        }
      } else {
        this.$refs.partnerAccountBox?.getRefs().resetFields()
      }
      this.model.channelType = this.bankChannelType

      this.$emit('change', val)
    },
  },
  computed: {
    ...mapGetters(['bankChannelType']),
  },
}
</script>

<style lang="scss" scoped>
.footer {
    text-align: center;
}
</style>
